module.exports = __webpack_public_path__ + "static/media/AUROPHARMA_F1.2ca6082e.txt";